export const getLpoaInfo = (state) => state.lpoa;
export const getHideLpoaModal = (state) => state.hideLpoaModal || false;
